import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FileUsageViewerDialogComponent } from 'projects/apex/src/app/components/file-usage-viewer/file-usage-viewer-dialog.component';
import {
  FileUsageViewerData,
  FileUsageViewerMode,
} from 'projects/apex/src/app/components/file-usage-viewer/file-usage-viewer.types';
import { AddonPackage } from 'projects/apex/src/app/models/addon-package';
import { Subscription } from 'rxjs';

@Component({
  selector: 'apex-addon-package-card',
  templateUrl: './addon-package-card.component.html',
  styleUrls: ['./addon-package-card.component.scss'],
})
export class AddonPackageCardComponent implements OnInit, OnDestroy {
  @Input() package: AddonPackage & {
    priceIn?: number;
    priceOut?: number;
    availabilityFrom?: Date;
    availabilityTo?: Date;
  };
  @Input() apartmentId: number;
  @Output() clicked = new EventEmitter<AddonPackage>();

  // Should be the price for the selected apartment including VAT
  packagePrice: number;

  private subs: Subscription[] = [];

  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {
    this.calculatePackagePrice();
  }

  emitClicked(): void {
    this.clicked.emit(this.package);
  }

  calculatePackagePrice(): void {
    this.packagePrice = this.package.priceOut;

    if (this.package.vatPercentage && this.package.vatPercentage > 0) {
      this.packagePrice = this.packagePrice * (1 + this.package.vatPercentage / 100);
    }
  }

  openFileUsages(): void {
    if (this.package?.gallery?.length) {
      const data: FileUsageViewerData = {
        fileUsages: this.package.gallery,
        mode: FileUsageViewerMode.View,
        editable: false,
        client: true,
      };

      this.dialog.open(FileUsageViewerDialogComponent, { data });
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s?.unsubscribe());
  }
}
